import React, { useEffect, useState } from "react";
import Loader from "../layout/Loader";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import MetaData from "../layout/MetaData";
import { useDeleteProductMutation, useGetAdminProductsQuery } from "../../redux/api/productsApi";
import AdminLayout from "../layout/AdminLayout";

const ListProducts = () => {
    const { data, isLoading, error } = useGetAdminProductsQuery();

    const [deleteProduct, { isLoading: isDeleteLoading, error: deleteError, isSuccess }] = useDeleteProductMutation()

    useEffect(() => {
        if (error) {
            toast.error(error?.data?.message);
        }
        if (deleteError) {
            toast.error(deleteError?.data?.message);
        }
        if (isSuccess) {
            toast.success("Product Deleted")
        }
    }, [error, deleteError, isSuccess]);

    const deleteProductHandler = (id) => {
        deleteProduct(id)
    }

    // Products array
    const products = data?.products || [];

    // Pagination state
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const totalPages = Math.max(1, Math.ceil(products.length / perPage));
    const startIdx = (page - 1) * perPage;
    const endIdx = Math.min(products.length, startIdx + perPage);
    const currentProducts = products.slice(startIdx, endIdx);

    if (isLoading) return <Loader />;

    return (
        <AdminLayout>
            <MetaData title="My Orders" />
            <div
                className="container-fluid py-4 mt-0 pt-0"
                style={{ fontFamily: "Quicksand, sans-serif" }}
            >


                <div className="card shadow-sm rounded-4 border-0 p-4 ">
                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
                        <h2 className="fw-bold m-0" style={{ color: "#e04f6e" }}>Products</h2>
                        <div className="d-flex align-items-center gap-2">
                            <span className="small" style={{ color: "#e04f6e" }}>Rows per page</span>
                            <select
                                className="form-select form-select-sm"
                                style={{ width: 90 }}
                                value={perPage}
                                onChange={(e) => { setPerPage(Number(e.target.value)); setPage(1); }}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                            </select>
                        </div>
                    </div>

                    <div className="d-flex flex-column gap-3">
                        {currentProducts.map((product) => (
                            <div key={product?._id} className="rounded-4 p-3 bg-white shadow-sm">
                                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
                                    <div>
                                        <div className="small fw-semibold" style={{ color: '#e04f6e' }}>Product ID</div>
                                        <div className="text-break">{product?._id}</div>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 flex-shrink-0">
                                        <Link to={`/admin/products/${product?._id}`} className="btn btn-outline-primary btn-sm">
                                            <i className="fa fa-pencil"></i>
                                        </Link>
                                        <Link to={`/admin/products/${product?._id}/upload_images`} className="btn btn-outline-success btn-sm">
                                            <i className="fa fa-image"></i>
                                        </Link>
                                        <button
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={() => deleteProductHandler(product?._id)}
                                            disabled={isDeleteLoading}
                                        >
                                            <i className="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                                <div className="d-flex flex-wrap gap-4">
                                    <div>
                                        <div className="small fw-semibold" style={{ color: '#e04f6e' }}>Name</div>
                                        <div className="text-break">{product?.name}</div>
                                    </div>
                                    <div>
                                        <div className="small fw-semibold" style={{ color: '#e04f6e' }}>Location</div>
                                        <div>
                                            <span className={`badge ${product?.displayLocation === 'homepage' ? 'bg-primary' : product?.displayLocation === 'both' ? 'bg-warning text-dark' : 'bg-secondary'}`}>
                                                {product?.displayLocation === 'homepage' ? 'Homepage' : product?.displayLocation === 'both' ? 'Both' : 'Filter Page'}
                                            </span>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="small fw-semibold" style={{ color: '#e04f6e' }}>Stock</div>
                                        <div>{product?.stock}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {products.length === 0 && (
                            <div className="text-center text-muted">No products found.</div>
                        )}
                    </div>

                    {/* Pagination controls */}
                    {products.length > 0 && (
                        <div className="d-flex flex-wrap justify-content-between align-items-center mt-3 gap-2">
                            <div className="small text-muted">Showing {products.length === 0 ? 0 : startIdx + 1}–{endIdx} of {products.length}</div>
                            <div className="d-flex align-items-center gap-2">
                                <button
                                    className="btn btn-sm btn-outline-secondary"
                                    disabled={page <= 1}
                                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                                >
                                    Prev
                                </button>
                                <span className="small">Page {page} of {totalPages}</span>
                                <button
                                    className="btn btn-sm btn-outline-secondary"
                                    disabled={page >= totalPages}
                                    onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>

        </AdminLayout>

    );
};

export default ListProducts;
